import React from 'react'
import calendar from "../dist/webImages/calendar.svg"
import clock from "../dist/webImages/wall-clock.svg"
import phonecall from "../dist/webImages/phone-call.svg"
import noimg from '../dist/webImages/no_image.jpg'
import dayjs from 'dayjs';
import { BookingTab } from '../data/data'




const truncateText = (text, maxLength) => {
    if (text) {
        if (text.length <= maxLength) {
            return text;
        }
        return text.slice(0, maxLength) + '...';
    }
    return text;
};
const BookingsCard = ({ data, modelDataUpdate, modelStatusUpdate }) => {
    const { id,transaction_id, order_number, first_name, booking_status, email, client_name, client_email, pickup_date_time, return_date_time, grand_total, consultant_designation, card_payment, payment_type, payment_status } = data
    const handleOpenModel = () => {
        modelStatusUpdate(true)
        modelDataUpdate(data)
    }

    const pickup_date = dayjs(pickup_date_time).format('YYYY-MM-DD HH:mm');
    const return_date = dayjs(return_date_time).format('YYYY-MM-DDTHH:mm');
    const maxLength = 50;
    const maxLength2 = 15;
    const truncatedText2 = truncateText(client_name, maxLength2);

    return (
        <div className="bookingBox cursor-pointer bg-[#A38560]/10 p-5 rounded-xl" onClick={handleOpenModel}>
            <ul className='list'>
                <li className='flex items-center justify-between gap-2'>
                    <div className='h2 text-[1.3rem] font-Mluvka flex items-center gap-1 leading-[1]'> <span className='bg-primary px-2 py-2 leading-3 text-white p-1 text-[.8rem] rounded-[.5rem]'>#{order_number}</span> {truncatedText2}</div>
                    <div className='flex gap-2'>
                        <span className='px-2 py-1 text-white rounded-[.5rem] bg-[#A38560] uppercase text-[.8rem]'>{booking_status}</span>
                        <span className='px-2 py-1 text-white rounded-[.5rem] bg-primary uppercase text-[.8rem]'>{payment_status}</span>
                    </div>

                </li>
            </ul>
            <div className="h3 mb-3">{client_email}</div>
            {/* <div className='flex items-center gap-1'><img src={Coffee} alt="Coffee" /><span className='font-Mluvka text-[.8rem]'>{beverage}</span></div> */}

                <span  className='font-MluvkaBold text-[.9rem] text-primary/50'>transaction id: {transaction_id}</span>
            <div className='calender my-4 flex items-center gap-2'>
                <img src={clock} className='w-[1.5rem]' alt="calender" />
                <span className='font-MluvkaBold text-[.9rem] text-primary/50'>{pickup_date} to {return_date}</span>
            </div>
            <div className='calender  flex items-center gap-2'>
                <span className='text-[1.3rem] font-semibold font-Cinzel capitalize'>{first_name}</span>
            </div>
            <div className='calender flex items-center gap-2'>
                <span className='font-MluvkaBold text-[.9rem] text-primary/50 '>{email}</span>
            </div>
            <div className='calender flex items-center gap-2'>
                <span className='font-MluvkaBold text-[.9rem] text-primary/50'>Payment Type:</span>
                <span className='font-MluvkaBold text-[.9rem] text-primary/50'>{payment_type}</span>
            </div>
            <div className='calender flex items-center gap-2'>
                <span className='font-MluvkaBold text-[.9rem] text-primary/50'>Card Payment:</span>
                <span className='font-MluvkaBold text-[.9rem] text-primary/50'>{card_payment}</span>
            </div>
            <div className='calender flex items-center gap-2'>
                <span className='font-MluvkaBold text-[.9rem] text-primary/50'>Price:</span>
                <span className='font-MluvkaBold text-[.9rem] text-primary/50'>{grand_total}</span>
            </div>
        </div>
    )
}

export default BookingsCard
